import { useAuth0 } from "@auth0/auth0-react";
import { Alert, Box, CircularProgress } from "@mui/material";
import createClient from "openapi-fetch";
import { useEffect, useState, type FC } from "react";
import { Navigate } from "react-router";
import type { paths } from "../../__definitions__/key.changeengine.com-definitions";
import { Page } from "../../modules/layout/components/page";
import { useFlags } from "../../server/optimizely";
import { serviceURL } from "../../utils/service-url";

const LabsPage: FC = () => {
  const {
    flags: { labs },
    flagsLoaded,
  } = useFlags("labs");
  const [displayError, setDisplayError] = useState<string>();
  const [token, setToken] = useState<string>();
  const { getAccessTokenSilently } = useAuth0();
  useEffect(() => {
    void (async () => {
      const accessToken = await getAccessTokenSilently();
      const key = createClient<paths>({
        baseUrl: serviceURL("key"),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const { data, error } = await key.POST("/labs", { body: {} });
      if (error) setDisplayError(error.error);
      if (data) setToken(data.key);
    })();
  }, [getAccessTokenSilently]);

  if (flagsLoaded && !labs) return <Navigate replace to="/" />;
  if (!token) {
    if (displayError) <Alert>{displayError}</Alert>;
    return <CircularProgress />;
  }
  return (
    <Page title="Labs | ChangeEngine">
      <Box
        component="main"
        sx={{
          height: "100vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Box
          component="iframe"
          src={`https://changeenginelabs.ai/embed-login?token=${token}`}
          title="Embedded content"
          sx={{
            display: "block",
            width: "100%",
            height: "100%",
            border: 0,
          }}
        />
      </Box>
    </Page>
  );
};

export default LabsPage;
